import { useEffect, useState } from "react";
import {
  Button,
  DocumentsList,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
  Chip,
  showToast,
  DevNote,
  TableAdv,
} from "../../../../../../components";

import {
  BillRateType,
  CommissionType,
  PayType,
  PlacementReferralType,
} from "../../../../../../assets/data/enumData";
import PayTypeModal from "./Payments/PayTypeModal";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { dateFormator } from "../../../../../../utils/dateFormator";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { addNewPlacementStart } from "../../../../../../redux/slices/placements/placementsSlice";
import { getEmployeeId, mapTableRows } from "../../../../../../utils";
import PaymentViewModel from "./Payments/PaymentViewModel";
import { additionalNotifiers } from "../../../../../../assets/data/candidatesData";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import axios from "axios";
import { itemIncomeAccountOptions } from "../../../../../../assets/data/projectData";
import { clearActiveGmail } from "../../../../../../redux/slices/setting/settingsSlice";

// import { dateFormator } ";
// import dateFormator from " "
const toFloat = (val) => Math.round(Number(val) * 100) / 100;

const Payments = ({ setActiveTab, onCancel, currentPlacement, editData, incomingData }) => {
  console.log("currentPlacement", currentPlacement);
  const isEditable = !!editData;
  const [isPayTypeModalOpen, setIsPayTypeModalOpen] = useState(false);
  const [ref, setRef] = useState(false);
  const dispatch = useDispatch();
  const [placementvisablemodel, setplacementvisablemodel] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState({});
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const [totalMargin, setTotalMargin] = useState(0);

  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  console.log("vendorId", vendorId, selectedPayments);
  const [activeAction, setActiveAction] = useState(""); // can be 'edit' or 'revise'
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const lastPayment =
    fetchPerticularData?.payments?.[fetchPerticularData.payments.length - 1];
  const combineAttachmentsPoLink =
    lastPayment?.poLink?.map((filePath) => ({
      filePath,
      name: "Purchase Order",
    })) || [];
  const getInitialValues = () => {
    const defaultValues = {
      effectiveDate: editData?.jobInfo?.startDate || incomingData?.startDate || "",
      payType: "",
      payRateAndHr: incomingData?.payRate ? String(incomingData.payRate) : "",
      billingType: incomingData?.billingType || "",
      billRate: incomingData?.billRate ? String(incomingData.billRate) : "",
      purchaseOrderNumber: "",
      vmsCharges: "",
      percent: "",
      subPercent: "",
      purchaseOrder: [],
      offeredSalary: "",
      targetPercentage: "",
      targetAmount: "",
      referralArray: [
        {
          id: uuidv4(),
          referralChargesType: "",
          referralCharges: "",
          referralType: "",
          ref: "",
        },
      ],
      ref: "",
    };

    const latestPay = editData?.payments?.[editData.payments.length - 1];
    if (latestPay) {
      defaultValues.payType = latestPay.payRate?.payType || "";
      defaultValues.payRateAndHr = latestPay.payRate?.payRatePerHour || "";
      defaultValues.billingType = latestPay.billRate?.type || "";
      defaultValues.billRate = latestPay.billRate?.rate || "";
      defaultValues.purchaseOrderNumber = latestPay.poNum || "";
      defaultValues.offeredSalary = latestPay.annualPay || "";
      defaultValues.targetAmount = latestPay.commission || "";
      defaultValues.vmsCharges = latestPay.vmsCharges || "";
      defaultValues.effectiveDate = latestPay.payRate?.effectiveDate || editData?.jobInfo?.startDate || "";
    } else if (incomingData) {
      const isPermanent = incomingData.placementType === 2;
      if (!isPermanent && incomingData.billRate && incomingData.payRate) {
        const bill = Number(incomingData.billRate) || 0;
        const pay = Number(incomingData.payRate) || 0;
        const commission = bill - pay;
        const commPct = bill > 0 ? (commission / bill) * 100 : 0;
        const payPct = bill > 0 ? (pay / bill) * 100 : 0;

        defaultValues.percent = String(payPct);
        defaultValues.offeredSalary = String(incomingData.payRate);
        defaultValues.targetAmount = String(toFloat(commission));
        defaultValues.targetPercentage = String(toFloat(commPct));
      } else if (isPermanent && incomingData.offeredSalary) {
        const targetPerc = incomingData.targetPercentage || 0;
        defaultValues.offeredSalary = String(incomingData.offeredSalary);
        defaultValues.targetPercentage = String(targetPerc);
        const targetAmount = toFloat(Number(incomingData.offeredSalary) * (Number(targetPerc) / 100));
        defaultValues.targetAmount = String(targetAmount);
      }
      
      if (incomingData.targetAmount && !defaultValues.targetAmount) {
         defaultValues.targetAmount = String(incomingData.targetAmount);
      }
    }

    return defaultValues;
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    getInitialValues(),
    {
      effectiveDate: { type: "date", required: true },
      payType: { type: "select", required: true },
      // payRateAndHr: { type: "text", required: true, number: true },
      // payRateAndHr: { type: "text", required: true },
      billingType: { type: "select", required: true },
      billRate: { type: "text", required: true, number: true },
      ...(combineAttachmentsPoLink?.length > 0
        ? {}
        : {
            purchaseOrder: {
              type: "file",
              required: true,
            },
          }),
    },
  );



  function debounce(func, wait) {
    let timeout;
    return (...args) => {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const handleSave = async () => {
    const isValid = validateAllFields();
    const currentPlacementUiid =
      currentPlacement?.uiid ||
      editData?.uiid ||
      currentPlacement?.data?.doc?.uiid ||
      "";
    const referralArray = formData?.referralArray || [];
    const referralArrayHasError = referralArray.some((item) =>
      item.referralCharges
        ? !(item.referralType && item.referral?.value)
        : false,
    );
    if (referralArrayHasError) {
      showToast("Referral is required if referral charges is entered", "error");
      return;
    }
    if (isValid) {
      if (!formData?.percent) {
        showToast("please fill percentage", "error");
        return "";
      }
      const submissionData = {
        _skipFlatten: ["referral"],
        incomingPlacementId: incomingData?.incomingPlacementId,
        payRate: {
          effectiveDate: formData.effectiveDate,
          payType: formData.payType, // PayType
          payRatePerHour: formData.payRateAndHr,
          percent: formData.percent,
          subPercent: formData.subPercent,
        },
        vmsCharges: formData.vmsCharges,
        poNum: formData.purchaseOrderNumber,
        // referral: {
        //   vendorId:
        //     formData?.referralType === 1
        //       ? formData?.referral?.value ?? formData?.referral
        //       : undefined,
        //   employeeId:
        //     formData?.referralType === 2
        //       ? formData?.referral?.value ?? formData?.referral
        //       : undefined,
        //   referralAmount: formData?.referralCharges || 0,
        // },
        referral:
          (formData?.referralArray || [])
            // .filter(
            //   (item) =>
            //     (!!item?.referral?.value ?? !!item?.referral) &&
            //     !!item?.referralCharges
            // )
            .map((item) => ({
              vendorId:
                item?.referralType == 1
                  ? (item?.referral?.value ?? item?.referral)
                  : null,
              employeeId:
                item?.referralType == 2
                  ? (item?.referral?.value ?? item?.referral)
                  : null,
              referralAmountType: item?.referralChargesType,
              referralAmount: Number(item?.referralCharges) || 0,
              margin:
                currentEmployee?.employeeDetails?.employmentType === 2 ||
                currentEmployee?.employeeDetails?.employmentType === 3
                  ? Number(totalMargin)
                  : null,
              percentage:
                currentEmployee?.employeeDetails?.employmentType === 2 ||
                currentEmployee?.employeeDetails?.employmentType === 3
                  ? Number(item?.percentage)
                  : null,
            })) || [],
        refEmployeeId: (formData?.ref?.value ?? formData?.ref) || undefined,
        billRate: {
          type: formData.billingType, // BillRateType
          rate: formData.billRate,
        },
        annualPay: formData.offeredSalary || 0,
        commission: formData.targetAmount || 0,
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const payments = fetchPerticularData?.payments;
      const paymentspatchId =
        activeAction !== "revise" &&
        Array.isArray(payments) &&
        payments.length > 0 &&
        payments[payments.length - 1]._id
          ? payments[payments.length - 1]._id
          : undefined;
      // if (paymentspatchId) {
      //   userFormData.updatedBy = employeeProfileUiid;
      //   userFormData.updatedOn = new Date();
      // }
      if (paymentspatchId) {
        submissionData.updated = {
          on: new Date(),
          by: employeeProfileUiid,
        };
      } else {
        submissionData.added = {
          on: new Date(),
          by: employeeProfileUiid,
        };
      }

      // const submissionData = filterEmptyValues(userFormData);
      // return;
      const cleanAttachments =
        Array.isArray(formData.purchaseOrder) &&
        formData.purchaseOrder.length > 0
          ? formData.purchaseOrder.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      if (cleanAttachments.length) {
        dispatch(
          // https://kw-workforce.s3.ap-south-2.amazonaws.com/tektree llc/workauths/101/visa/04_2025/8b09ee45e27cd2e385803d67cd33b1fd_1745471547767.pdf
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "placements",
            category: "payments",
            coll: "Placement",
            doc: cleanAttachments,
            onSuccess: (fileData) => {
              // Step 3: Store document references

              dispatch(
                addNewPlacementStart({
                  uiid: uiid,
                  rsd: {
                    ...submissionData,
                    poLink: fileData.map((file) => file.key),
                  },
                  rsn: "clientPlacementPayments",
                  ...(paymentspatchId && { patchId: paymentspatchId }),
                  payload: [
                    {
                      type: paymentspatchId ? "SET" : "PUSH",
                      value: {
                        [paymentspatchId ? "payments.$[elem]" : "payments"]: {
                          ...submissionData,
                          poLink: fileData.map((file) => file.key),
                        },
                      },
                    },
                  ],
                  onSuccess: async (payload) => {
                    setActiveTab((prev) => prev + 1);
                  },
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addNewPlacementStart({
            uiid: uiid,
            rsd: {
              ...submissionData,
            },
            rsn: "clientPlacementPayments",
            ...(paymentspatchId && { patchId: paymentspatchId }),
            payload: [
              {
                type: paymentspatchId ? "SET" : "PUSH",
                value: {
                  [paymentspatchId ? "payments.$[elem]" : "payments"]: {
                    ...submissionData,
                  },
                },
              },
            ],
            onSuccess: async (payload) => {
              setActiveTab((prev) => prev + 1);
            },
          }),
        );
      }
      // setTimeout(() => {
      //   setActiveTab((prev) => prev + 1);
      // }, 500);
    } else {
      showToast(
        "please fill the required feilds before you submitting",
        "error",
      );
    }
  };

  const handleCancel = () => {
    // console.log("cancel clicked....");
    if (onCancel) {
      onCancel();
    }
  };
  console.log("formdata in payments", formData);



  // const handleChangeBillRate = (field, value) => {
  //   const billRate = Number(value).toFixed(2) || 0;
  //   const referralCharges = Number(formData?.referralCharges).toFixed(2) || 0;

  //   const vmsCharges = Number(formData?.vmsCharges).toFixed(2) || 0;
  //   let afterDeduction = billRate;
  //   if (Number(vmsCharges).toFixed(2) > 0) {
  //     afterDeduction = Number(billRate).toFixed(2) * (1 - Number(vmsCharges).toFixed(2) / 100);
  //   }
  //   const percent = formData?.percent || 0;
  //   const subPercent = formData?.subPercent || 0;
  //   // Check if both percent and subPercent are valid before doing the calculation
  //   let deducted = afterDeduction;
  //   if (Number(percent).toFixed(2) > 0) {
  //     deducted = Number(afterDeduction).toFixed(2) * (Number(percent).toFixed(2) / 100);
  //   }
  //   if (Number(subPercent).toFixed(2) > 0) {
  //     deducted = Number(deducted).toFixed(2) * (Number(subPercent).toFixed(2) / 100);
  //   }
  //   handleChange("billRate", Number(value).toFixed(2));
  //   handleChange(
  //     "payRateAndHr",
  //     `${Number(deducted - referralCharges).toFixed(2)}`
  //   );
  // };

  const handleChangeBillRate = (field, value) => {
    handleChange("billRate", value); // allow user to type freely

    const billRateNum = Number(value);
    if (isNaN(billRateNum)) return;

    const referralCharges =
      Math.round(Number(formData?.referralCharges) * 100) / 100 || 0;
    const vmsCharges =
      Math.round(Number(formData?.vmsCharges) * 100) / 100 || 0;

    let afterDeduction = billRateNum;
    if (vmsCharges > 0) {
      afterDeduction =
        Math.round(billRateNum * (1 - vmsCharges / 100) * 100) / 100;
    }

    const percent = Math.round(Number(formData?.percent) * 100) / 100 || 0;
    const subPercent =
      Math.round(Number(formData?.subPercent) * 100) / 100 || 0;

    let deducted = afterDeduction;
    if (percent > 0) {
      deducted = Math.round(afterDeduction * (percent / 100) * 100) / 100;
    }
    if (subPercent > 0) {
      deducted = Math.round(deducted * (subPercent / 100) * 100) / 100;
    }

    const payRate = Math.round((deducted - referralCharges) * 100) / 100;

    handleChange("payRateAndHr", toFloat(payRate));
  };

  // const handleChangeVmsChanges = (field, value) => {
  //   const billRate = Number(formData?.billRate).toFixed(2) || 0;
  //   const vmsCharges = Number(value).toFixed(2) || 0;
  //   let afterDeduction = billRate;
  //   //working
  //   // const referralCharges = Number(formData?.referralCharges) || 0;
  //   //testing

  //   if (Number(vmsCharges) > 0) {
  //     afterDeduction = Number(billRate).toFixed(2) * (1 - Number(vmsCharges).toFixed(2) / 100);
  //   }
  //   const percent = formData?.percent || 0;
  //   const subPercent = formData?.subPercent || 0;
  //   // Check if both percent and subPercent are valid before doing the calculation
  //   let deducted = afterDeduction;
  //   if (Number(percent).toFixed(2) > 0) {
  //     deducted = Number(afterDeduction).toFixed(2) * (Number(percent).toFixed(2) / 100);
  //   }
  //   if (Number(subPercent) > 0) {
  //     deducted = Number(deducted).toFixed(2) * (Number(subPercent).toFixed(2) / 100);
  //   }

  //   const referralCharges =
  //     formData?.referralArray?.reduce((total, item) => {
  //       const charge = Number(
  //         item.referralChargesType === 2
  //           ? Number(value).toFixed(2) * (Number(deducted).toFixed(2) / 100)
  //           : item.referralCharges
  //       ).toFixed(2);
  //       return total + (isNaN(charge) ? 0 : charge);
  //     }, 0) || 0;
  //   handleChange("vmsCharges", Number(value).toFixed(2));
  //   handleChange(
  //     "payRateAndHr",
  //     `${Number(deducted - referralCharges).toFixed(2)}`
  //   );
  // };
  const handleChangeVmsChanges = (field, value) => {
    handleChange("vmsCharges", value);

    const billRate = Math.round(Number(formData?.billRate) * 100) / 100 || 0;
    const vmsCharges = Math.round(Number(value) * 100) / 100 || 0;

    let afterDeduction = billRate;
    if (vmsCharges > 0) {
      afterDeduction =
        Math.round(billRate * (1 - vmsCharges / 100) * 100) / 100;
    }

    const percent = Math.round(Number(formData?.percent) * 100) / 100 || 0;
    const subPercent =
      Math.round(Number(formData?.subPercent) * 100) / 100 || 0;

    let deducted = afterDeduction;
    if (percent > 0) {
      deducted = Math.round(afterDeduction * (percent / 100) * 100) / 100;
    }
    if (subPercent > 0) {
      deducted = Math.round(deducted * (subPercent / 100) * 100) / 100;
    }

    const referralCharges =
      formData?.referralArray?.reduce((total, item) => {
        const charge =
          item.referralChargesType === 2
            ? Math.round(vmsCharges * (deducted / 100) * 100) / 100
            : Math.round(Number(item.referralCharges) * 100) / 100;

        return total + (isNaN(charge) ? 0 : charge);
      }, 0) || 0;

    const payRate = Math.round((deducted - referralCharges) * 100) / 100;

    handleChange("payRateAndHr", toFloat(payRate));
  };

  // const handleChangeReferralCharges = (field, value, index) => {
  //   const billRate = Number(formData?.billRate).toFixed(2) || 0;
  //   if (!billRate) {
  //     showToast("Enter Bill Rate", "error", "3000");
  //     return;
  //   }
  //   if (isNaN(Number(value))) return;
  //   //previous
  //   // const referralCharges = parseFloat(value) || 0;
  //   // const referralCharges = formData?.referralArray?.reduce(
  //   //   (total, item) => total + parseFloat(item.referralCharges),
  //   //   0
  //   // ) || 0;

  //   const vmsCharges = Number(formData?.vmsCharges).toFixed(2) || 0;
  //   const percent = Number(formData?.percent).toFixed(2) || 0;
  //   const subPercent = Number(formData?.subPercent).toFixed(2) || 0;

  //   let afterDeduction = billRate;

  //   if (vmsCharges > 0) {
  //     afterDeduction = billRate * (1 - vmsCharges / 100);
  //   }

  //   let deducted = Number(afterDeduction).toFixed(2);

  //   if (percent > 0) {
  //     deducted = afterDeduction * (percent / 100);
  //   }

  //   if (subPercent > 0) {
  //     deducted = deducted * (subPercent / 100);
  //   }
  //   // console.log(
  //   //   "before deducting referral charges",
  //   //   "deducted",
  //   //   deducted,
  //   //   "referralCharges",
  //   //   referralCharges
  //   // );
  //   const referralCharges =
  //     formData?.referralArray?.reduce((total, item, i) => {
  //       if (i === index && item.referralChargesType === 2) {
  //         if (Number(value).toFixed(2) > 90) {
  //           showToast(
  //             "Referral charge value can't exceed 90% for Percentage",
  //             "error",
  //             "3000"
  //           );
  //           throw new Error("Referral charge value too high");
  //         }
  //       }

  //       const charge =
  //         i === index
  //           ? Number(
  //               item.referralChargesType === 2
  //                 ? Number(value).toFixed(2) * (Number(deducted).toFixed(2) / 100)
  //                 : value
  //             ).toFixed(2)
  //           : // : parseFloat(item.referralCharges);
  //             Number(
  //               item.referralChargesType === 2
  //                 ? Number(item.referralCharges).toFixed(2) * (Number(deducted).toFixed(2) / 100)
  //                 : item.referralCharges
  //             ).toFixed(2);
  //       return total + (isNaN(charge) ? 0 : charge);
  //     }, 0) || 0;
  //   const finalRate = deducted - referralCharges;
  //   // console.log(
  //   //   "after deducting referral charges",
  //   //   "finalRate",
  //   //   finalRate,
  //   //   "deducted",
  //   //   deducted,
  //   //   "referralCharges",
  //   //   referralCharges,
  //   //   "formData?.referralArray",
  //   //   formData?.referralArray
  //   // );

  //   handleChange(`referralArray[${index}].referralCharges`, Number(value).toFixed(2));
  //   handleChange("payRateAndHr", `${Number(finalRate).toFixed(2)}`);
  // };

  const handleChangeReferralCharges = (field, value, index) => {
    handleChange(`referralArray[${index}].referralCharges`, value);
    const billRate = Math.round(Number(formData?.billRate) * 100) / 100 || 0;
    if (!billRate) {
      showToast("Enter Bill Rate", "error", "3000");
      return;
    }

    if (isNaN(Number(value))) return;

    const vmsCharges =
      Math.round(Number(formData?.vmsCharges) * 100) / 100 || 0;
    const percent = Math.round(Number(formData?.percent) * 100) / 100 || 0;
    const subPercent =
      Math.round(Number(formData?.subPercent) * 100) / 100 || 0;

    let afterDeduction = billRate;
    if (vmsCharges > 0) {
      afterDeduction =
        Math.round(billRate * (1 - vmsCharges / 100) * 100) / 100;
    }

    let deducted = afterDeduction;
    if (percent > 0) {
      deducted = Math.round(deducted * (percent / 100) * 100) / 100;
    }
    if (subPercent > 0) {
      deducted = Math.round(deducted * (subPercent / 100) * 100) / 100;
    }

    const referralCharges =
      formData?.referralArray?.reduce((total, item, i) => {
        const val = Math.round(Number(value) * 100) / 100;

        if (i === index && item.referralChargesType === 2 && val > 90) {
          showToast(
            "Referral charge value can't exceed 90% for Percentage",
            "error",
            "3000",
          );
          throw new Error("Referral charge value too high");
        }

        const charge =
          i === index
            ? item.referralChargesType === 2
              ? Math.round(val * (deducted / 100) * 100) / 100
              : val
            : item.referralChargesType === 2
              ? Math.round(
                  Number(item.referralCharges) * (deducted / 100) * 100,
                ) / 100
              : Math.round(Number(item.referralCharges) * 100) / 100;

        return total + (isNaN(charge) ? 0 : charge);
      }, 0) || 0;

    const finalRate = Math.round((deducted - referralCharges) * 100) / 100;

    handleChange("payRateAndHr", toFloat(finalRate));
  };

  const paymentsList = fetchPerticularData?.payments ?? [];

  const columns = [
    {
      key: "effectiveDate",
      label: "Effective Date",
      sortable: false,
      render: (row) => (
        <div>{dateFormator(row?.payRate?.effectiveDate, "month-day-year")}</div>
      ),
    },
    //  {
    //   key: "effectiveTill",
    //   label: "Effective Till",
    //   sortable: false,
    //   render: (row) => <div>{dateFormator(row?.payRate?.effectiveTill, "month-day-year")}</div>,
    // },
    {
      key: "billRate",
      label: "Bill Rate",
      sortable: false,
      render: (row) => <div>{row?.billRate?.rate}</div>,
    },
    {
      key: "payRate",
      label: "Pay Rate",
      sortable: false,
      render: (row) => <div>{row?.payRate?.payRatePerHour}</div>,
    },
    {
      key: "payType",
      label: "Pay Type",
      sortable: false,
      render: (row) => <div>{row?.payRate?.payType}</div>,
    },
    {
      key: "createdDate",
      label: "Created Date",
      sortable: false,
      render: (row) => (
        <div>{dateFormator(row?.added?.on, "month-day-year")}</div>
      ),
    },
    {
      key: "modifiedDate",
      label: "Modified Date",
      sortable: false,
      render: (row) => (
        <div>{dateFormator(row?.updated?.on, "month-day-year")}</div>
      ),
    },
    {
      key: "createdBy",
      label: "Created By",
      sortable: false,
      render: (row) => <div>{row?.added?.firstName || ""}</div>,
    },
    {
      key: "modifiedBy",
      label: "Modified By",
      sortable: false,
      render: (row) => <div>{row?.updated?.firstName || ""}</div>,
    },
    {
      key: "poNumber",
      label: "PO Number",
      sortable: false,
      render: (row) => <div>{row?.poNum}</div>,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => {
        return (
          <Button
            type="icon"
            variant="text"
            icon="visibility"
            size="xs"
            color="black"
            onClick={() => {
              setplacementvisablemodel(true); // corrected camelCase
              setSelectedPayments(row);
            }}
          />
        );
      },
      sortable: false,
    },
  ];
  const mappedRows = mapTableRows(paymentsList, columns);

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;

      const filter = {
        uiid: { type: "NONE", value: uiid },
      };

      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "vendor.id jobInfo.startDate uiid payments vendor.id",
            ref: "RefVendor RefEmployee",
          },
        });

        const data = response?.data?.data;
        console.log("data", data);
        const payments = data?.payments || [];

        // Step 1: Get unique 'by' IDs
        const uniqueByValues = [
          ...new Set(
            payments.flatMap((item) => {
              const ids = [];
              if (typeof item?.added?.by === "number") ids.push(item.added.by);
              if (typeof item?.updated?.by === "number")
                ids.push(item.updated.by);
              return ids;
            }),
          ),
        ];

        // Step 2: Fetch user data based on those IDs
        let userMap = {};
        if (uniqueByValues.length > 0) {
          const userFilter = {
            uiid: { type: "NONE", value: uniqueByValues },
          };

          const userResponse = await axiosRequest({
            method: "GET",
            url: ENDPOINTS.USERS.GET_ALL,
            params: {
              coll: "User",
              fil: JSON.stringify(userFilter),
              ret: "firstName uiid",
            },
          });

          const users = userResponse?.data?.data || [];
          // Create a quick lookup map { uiid: firstName }
          userMap = users.reduce((acc, user) => {
            acc[user.uiid] = user.firstName;
            return acc;
          }, {});
        }

        // Step 3: Add firstName to each added/updated block in payments
        const enrichedPayments = payments.map((payment) => {
          const addedBy = payment?.added?.by;
          const updatedBy = payment?.updated?.by;

          return {
            ...payment,
            added:
              addedBy !== undefined
                ? {
                    ...payment.added,
                    firstName: userMap[addedBy] || undefined,
                  }
                : payment.added,
            updated:
              updatedBy !== undefined
                ? {
                    ...payment.updated,
                    firstName: userMap[updatedBy] || undefined,
                  }
                : payment.updated,
          };
        });

        // Optional: Save enrichedPayments to state if needed
        setFetchPerticularData({
          ...data,
          payments: enrichedPayments,
        });
        // console.log("data", data);
        setVendorId(data?.vendor?.id);

        // Step 4: Update form fields from the last payment
        const lastPayment = enrichedPayments[enrichedPayments.length - 1];
        if (lastPayment) {
  handleChange("payType", lastPayment?.payRate?.payType);
  handleChange(
    "payRateAndHr",
    `${lastPayment?.payRate?.payRatePerHour || ""}`
  );

  // ✅ Do not override values if incomingData exists
  if (!incomingData) {
    handleChange("percent", String(lastPayment?.payRate?.percent ?? ""));
    handleChange(
      "subPercent",
      String(lastPayment?.payRate?.subPercent ?? "")
    );
  }

  handleChange("vmsCharges", lastPayment?.vmsCharges);
  handleChange("purchaseOrderNumber", lastPayment?.poNum);
  handleChange("billingType", lastPayment?.billRate?.type);
  handleChange("billRate", `${lastPayment?.billRate?.rate || ""}`);
}

        // handleChange("effectiveDate", data?.jobInfo?.startDate);
        if (!incomingData) {
  handleChange(
    "effectiveDate",
    lastPayment?.payRate?.effectiveDate
      ? lastPayment?.payRate?.effectiveDate
      : data?.jobInfo?.startDate
  );
}

        //added prefill here for the scenario 1 related to the refereal setings and ref employee
        // handleChange("referralCharges", lastPayment?.referral?.referralAmount);
        // handleChange("referralType", lastPayment?.referral?.vendorId ? 1 : 2);
        // handleChange(
        //   "referral",
        //   lastPayment?.referral?.vendorId ?? lastPayment?.referral?.employeeId
        // );
        //changed to multiple refrral setttings
        handleChange(
          "referralArray",
          lastPayment?.referral?.length > 0
            ? lastPayment?.referral?.map((item, i) => {
                // margin:
                //     currentEmployee?.employeeDetails?.employmentType === 2 ||
                //       currentEmployee?.employeeDetails?.employmentType === 3
                //       ? Number(item?.margin)
                //       : null,
                if (
                  currentEmployee?.employeeDetails?.employmentType === 2 ||
                  currentEmployee?.employeeDetails?.employmentType === 3
                ) {
                  setTotalMargin(item?.margin || 0);
                }
                return {
                  id: item?._id || i,
                  referralChargesType: item?.referralAmountType,
                  referralCharges: item?.referralAmount,
                  referralType: item?.vendorId ? 1 : item?.employeeId ? 2 : "",
                  percentage:
                    currentEmployee?.employeeDetails?.employmentType === 2 ||
                    currentEmployee?.employeeDetails?.employmentType === 3
                      ? Number(item?.percentage)
                      : null,
                  // referral: item?.vendorId ?? item?.employeeId,
                  referral: item?.vendorId
                    ? {
                        label: item?.vendorId?.businessName,
                        value: item?.vendorId?.uiid,
                      }
                    : {
                        label: `${item?.employeeId?.firstName} ${
                          item?.employeeId?.firstName
                        } ${getEmployeeId(
                          item?.employeeId?.uiid,
                          item?.employeeId?.employmentType,
                        )}`,
                        value: item?.employeeId?.uiid,
                      },
                };
              })
            : [
                {
                  id: uuidv4(),
                  referralChargesType: "",
                  referralCharges: "",
                  referralType: "",
                  ref: "",
                },
              ],
        );
        handleChange("ref", lastPayment?.refEmployeeId);
        setRef(!!lastPayment?.refEmployeeId);
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);

  const getProfit = (rate) => {
    const c2cTypeToAllow = [2, 3];

    if (
      c2cTypeToAllow.includes(currentEmployee?.employeeDetails?.employmentType)
    ) {
      setTotalMargin(Number(rate));
      handleChange(`referralArray.0.referralChargesType`, 2);
      // handleChange(
      //   `referralArray.0.referralCharges`,
      //   (Number(rate) / 2).toFixed(2)
      // );
    }
  };

  return (
    // <div className="w-full  px-8 py-6 border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="w-full  px-8 py-6 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="mb-3">
        <PageHeader
          Section={
            <div className="flex justify-between">
              <div>
                <PageTitle title={"Bill Rate"} tag="h6" />
              </div>
              {isEditable && (
                <div className="flex justify-end gap-2">
                  <Button
                    title="Edit Current Revision"
                    size="sm"
                    onClick={() => setActiveAction("edit")}
                  />
                  <Button
                    title="Revise Payments"
                    size="sm"
                    onClick={() => setActiveAction("revise")}
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6 ">
        <div className="col-span-1">
          <FormFieldSet
            type="datepicker"
            title={"Effective Date"}
            placeholder="Select Effective Date"
            value={formData.effectiveDate}
            onChange={(value) => handleChange("effectiveDate", value)}
            error={errors.effectiveDate}
            // disabled={isEditable ? (activeAction ? false : true) : true}
            showDropdown={false}
          />
        </div>
        <div className="col-span-1">
          <FormFieldSet
            type="select"
            title={"Billing Type"}
            placeholder="Select Billing Type"
            value={formData.billingType}
            onChange={(value) => {
              handleChange("billingType", value);
              handleChange("billRate", "");
              handleChange("vmsCharges", 0);
              formData.referralArray?.forEach((item, i) => {
                handleChange(`referralArray.${i}.referralCharges`, "");
              });
              handleChange("payRateAndHr", 0);
            }}
            error={errors.billingType}
            options={BillRateType}
            disabled={isEditable ? (activeAction ? false : true) : false}
          />
        </div>
        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Bill Rate"}
            placeholder="Enter Bill Rate"
            // value={formData.billRate - (formData.referralCharges || 0)}
            value={formData.billRate}
            onChange={(value) => handleChangeBillRate("billRate", value)}
            error={errors.billRate}
            disabled={isEditable ? (activeAction ? false : true) : false}
          />
        </div>
        <div className="col-span-1">
          <div className="flex items-center">
            <div className="flex-1">
              <FormFieldSet
                type="text"
                title={"VMS Charges"}
                placeholder="Enter VMS Charges"
                value={formData.vmsCharges}
                onChange={(value) =>
                  handleChangeVmsChanges("vmsCharges", value)
                }
                error={errors.vmsCharges}
                disabled={isEditable ? (activeAction ? false : true) : false}
              />
            </div>
            <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div>
          </div>
        </div>
        {/* <DevNote>
          <div>
            <h6>Calculated VMS + Bill Rate</h6>
            {(() => {
              const billRate = parseInt(formData?.billRate || 0);
              const vmsCharges = parseInt(formData?.vmsCharges || 0);
              return billRate * (1 - vmsCharges / 100);
            })()}
          </div>
          <div>
            <h6>Total Referral Charges</h6>
            {formData?.referralArray?.reduce((total, item) => {
              const adjustedBillRate =
                parseInt(formData.billRate) *
                (1 - parseInt(formData.vmsCharges) / 100);
              const charge = parseFloat(
                item.referralChargesType === 2
                  ? (adjustedBillRate / 100) * item.referralCharges
                  : item.referralCharges
              );
              return total + (isNaN(charge) ? 0 : charge);
            }, 0)}
          </div>
        </DevNote> */}
        <div className="col-span-1 hidden">
          <div className="flex items-center">
            <div className="flex-1">
              <FormFieldSet
                type="text"
                title={"Referral Charges"}
                placeholder="Enter Referral Charges"
                value={formData.vmsCharges}
                onChange={(value) =>
                  // handleChangeVmsChanges("vmsCharges", value)
                  handleChange("vmsCharges", value)
                }
                error={errors.vmsCharges}
                disabled={isEditable ? (activeAction ? false : true) : false}
              />
            </div>

            {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
          </div>
        </div>
      </div>

      {/* Referal Settings For Employment Type 1 - Scenario 1 */}
      <div
        className={`my-4 ${
          currentEmployee.employeeDetails.employmentType == 2 ||
          currentEmployee.employeeDetails.employmentType == 3
            ? "hidden"
            : ""
        }`}
      >
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Referral"} tag="h6" />
            </div>
          }
          RightSection={
            <div>
              <Button
                // type="link"
                icon="add"
                size="sm"
                variant="text"
                color="info"
                title={"Add Referral"}
                onClick={debounce(() => {
                  if (formData.referralArray.length === 5) return;
                  const referralObj = {
                    id: uuidv4(),
                    referralChargesType: "",
                    referralCharges: "",
                    referralType: "",
                    ref: "",
                  };  
                  handleChange("referralArray", [
                    ...formData.referralArray,
                    referralObj,
                  ]);
                }, 300)}
                // onClick={() => downloadInvoice()}
              />
            </div>
          }
        />
      </div>
      {(formData?.referralArray || [])?.map((item, index) => (
        <div
          className={`grid  grid-cols-2 lg:grid-cols-4  max-w-7xl gap-x-8 gap-y-6 mt-4  ${
            currentEmployee.employeeDetails.employmentType == 2 ||
            currentEmployee.employeeDetails.employmentType == 3
              ? "hidden"
              : ""
          }`}
          key={item?.id || index}
        >
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="select"
                  title={"Referral Charges Type"}
                  placeholder="Please Select"
                  // value={formData.referralType}
                  value={formData.referralArray[index].referralChargesType}
                  onChange={(value) => {
                    // handleChangeVmsChanges("vmsCharges", value)
                    handleChange(
                      `referralArray[${index}].referralChargesType`,
                      value,
                    );
                    //working
                    // handleChange(`referralArray[${index}].referralCharges`, "");
                    handleChangeReferralCharges(
                      `referralArray[${index}].referralCharges`,
                      0,
                      index,
                    );
                  }}
                  options={CommissionType}
                  // error={`errors.referralArray[${index}].referralType`}
                  // disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title={"Referral Charges"}
                  placeholder="Enter Referral Charges"
                  value={formData.referralArray[index].referralCharges}
                  onChange={(value) =>
                    // handleChangeVmsChanges("vmsCharges", value)
                    // handleChange("referralCharges", Number(value))
                    handleChangeReferralCharges(
                      `referralArray[${index}].referralCharges`,
                      value,
                      index,
                    )
                  }
                  // error={`errors.referralCharges[${index}].referralCharges`}
                  // disabled={isEditable ? (activeAction ? false : true) : false  }
                  disabled={
                    (isEditable && !activeAction) ||
                    !formData?.referralArray?.[index]?.referralChargesType
                  }
                />
              </div>
              {item.referralChargesType === 2 && (
                <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
                  %
                </div>
              )}
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="select"
                  title={"Select Referral Type"}
                  placeholder="Select Referral Type"
                  // value={formData.referralType}
                  value={formData.referralArray[index].referralType}
                  onChange={(value) => {
                    // handleChangeVmsChanges("vmsCharges", value)
                    handleChange(`referralArray[${index}].referralType`, value);
                    handleChange(`referralArray[${index}].referral`, "");
                  }}
                  options={PlacementReferralType}
                  // error={`errors.referralArray[${index}].referralType`}
                  // disabled={isEditable ? (activeAction ? false : true) : false}
                  disabled={
                    (isEditable && !activeAction) ||
                    !formData?.referralArray?.[index]?.referralChargesType
                  }
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
          <div className="col-span-1 ">
            <div className="flex items-center">
              <div
                className={`flex-1 ${
                  formData.referralArray[index].referralType ? "" : "hidden"
                }`}
              >
                {console.log("vendorId for exclude", vendorId)}
                <FormFieldSet
                  type={
                    formData.referralArray[index].referralType === 1
                      ? "allVendorsList"
                      : formData.referralArray[index].referralType === 2
                        ? "employeesConsultantFullNames"
                        : "select"
                  }
                  title={
                    formData.referralArray[index].referralType &&
                    "Select Referral "
                  }
                  placeholder="Select Referral"
                  value={formData.referralArray[index].referral}
                  onChange={(value) =>
                    // handleChangeVmsChanges("vmsCharges", value)
                    // handleChange("referral", value)
                    handleChange(`referralArray[${index}].referral`, value)
                  }
                  filters={{
                    entityId: vendorId,
                    entityType: "Vendor",
                  }}
                  showSearch
                  // error={`errors.referralArray[${index}].referral`}
                  disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>

              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
        </div>
      ))}

      <div className="my-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Pay Rate"} tag="h6" />
            </div>
          }
        />
      </div>
      <div className="grid  grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6 ">
        <div className="col-span-1">
          <div className="flex items-center">
            <div className="flex-1">
              <FormFieldSet
                type="select"
                title={"Pay Type"}
                placeholder="Select Pay Type"
                value={formData.payType}
                onChange={(value) => handleChange("payType", value)}
                error={errors.payType}
                options={PayType}
                disabled={isEditable ? (activeAction ? false : true) : false}
              />
            </div>

            <div
              className={`bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm  ${
                isEditable
                  ? activeAction
                    ? "cursor-pointer"
                    : "hidden"
                  : "cursor-pointer"
              }`}
              onClick={() => {
                // if (isEditable) return;
                setIsPayTypeModalOpen(true);
              }}
            >
              %
            </div>
          </div>
        </div>
        <div className="col-span-1">
          {console.log("formData.payType ", formData.payType)}
          <FormFieldSet
            type="text"
            title={formData.payType === 1 ? "Pay Rate / Hr" : "Pay Rate"}
            placeholder={
              formData.payType === 1 ? "Enter Pay Rate / Hr" : "Enter Pay Rate"
            }
            value={formData.payRateAndHr}
            onChange={(value) => handleChange("payRateAndHr", value)}
            error={errors.payRateAndHr}
            disabled={true}
          />
        </div>

        <div className="col-span-1">
          <FormFieldSet
            type="text"
            title={"Purchase Order Number"}
            placeholder="Enter Purchase Order Number"
            value={formData.purchaseOrderNumber}
            onChange={(value) => handleChange("purchaseOrderNumber", value)}
            error={errors.purchaseOrderNumber}
            disabled={isEditable ? (activeAction ? false : true) : false}
          />
        </div>
        <div className="col-span-1">
          <FormFieldSet
            type="file"
            title={"Purchase Order"}
            placeholder="Choose File"
            value={formData.purchaseOrder}
            // multiple
            onChange={(value) => handleChange("purchaseOrder", value)}
            error={errors.purchaseOrder}
            disabled={isEditable ? (activeAction ? false : true) : false}
          />
        </div>
        {combineAttachmentsPoLink.length > 0 && (
          <div
            className=" flex rounded-md items-center cursour-pointer"
            onClick={() => {
              setAttachmentModal(!attachmentModal);
              setSelectedDocuments(combineAttachmentsPoLink);
            }}
          >
            <Chip
              label={`Purchase Order:-${combineAttachmentsPoLink.length}`}
              icon={"docs"}
              iconPosition={"before"}
            />
          </div>
        )}
        {/* {Array.isArray(currentPlacement?.clientPlacementPayments?.poLink) && (
  <div>
    <DocumentsList
      data={currentPlacement.clientPlacementPayments.poLink.map((data) => ({
        filePath: data,
        name: "Purchase Order",
      }))}
    />
  </div>
)} */}
      </div>
      {/* Referal Settings For Employment Type 2 & 3 - Scenario 2 */}
      <div
        className={`my-4 ${
          currentEmployee.employeeDetails.employmentType == 2 ||
          currentEmployee.employeeDetails.employmentType == 3
            ? ""
            : "hidden"
        }`}
      >
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Referral"} tag="h6" />
            </div>
          }
          RightSection={
            <div className="hidden">
              <Button
                // type="link"
                icon="add"
                size="sm"
                variant="text"
                color="info"
                title={"Add Referral"}
                onClick={debounce(() => {
                  if (formData.referralArray.length === 5) return;
                  const referralObj = {
                    id: uuidv4(),
                    referralChargesType: "",
                    referralCharges: "",
                    referralType: "",
                    ref: "",
                  };
                  handleChange("referralArray", [
                    ...formData.referralArray,
                    referralObj,
                  ]);
                }, 300)}
                // onClick={() => downloadInvoice()}
              />
            </div>
          }
        />
      </div>
      {(formData?.referralArray || [])?.map((item, index) => (
        <div
          className={`grid  grid-cols-3 max-w-7xl gap-x-8 gap-y-6 my-4  ${
            currentEmployee.employeeDetails.employmentType == 2 ||
            currentEmployee.employeeDetails.employmentType == 3
              ? ""
              : "hidden"
          }`}
          key={item?.id || index}
        >
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title={"Margin"}
                  // placeholder="Referral Charges Type"
                  value={totalMargin}
                  disabled={true}
                  // value={formData?.referralArray?.[index]?.referralChargesType || 1}
                  // value={
                  //   formData?.referralArray?.[index]?.referralChargesType || 2
                  // }
                  // onChange={(value) => {
                  //   // handleChangeVmsChanges("vmsCharges", value)
                  //   handleChange(
                  //     `referralArray[${index}].referralChargesType`,
                  //     value
                  //   );
                  //   //working
                  //   handleChange(`referralArray[${index}].referralCharges`, "");
                  //   // handleChangeReferralCharges(
                  //   //   `referralArray[${index}].referralCharges`,
                  //   //   0,
                  //   //   index
                  //   // );
                  // }}
                  // disabled={true}
                  // options={PlacementCommissionType}
                  // options={[{ label: "Flat", value: 1 }]}
                  // error={`errors.referralArray[${index}].referralType`}
                  // disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="select"
                  title={"Referral Charges Type"}
                  placeholder="Referral Charges Type"
                  // value={formData.referralType}
                  // value={formData?.referralArray?.[index]?.referralChargesType || 1}
                  // value={formData?.referralArray?.[index]?.referralChargesType}

                  value={2}
                  onChange={(value) => {
                    // handleChangeVmsChanges("vmsCharges", value)
                    handleChange(
                      `referralArray[${index}].referralChargesType`,
                      value,
                    );
                    //working
                    handleChange(`referralArray[${index}].referralCharges`, "");
                    // handleChangeReferralCharges(
                    //   `referralArray[${index}].referralCharges`,
                    //   0,
                    //   index
                    // );
                  }}
                  disabled={true}
                  options={CommissionType}
                  // options={[{ label: "Percentage", value: 2 }]}
                  // error={`errors.referralArray[${index}].referralType`}
                  // disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title={"Enter Percentage"}
                  placeholder="Enter Percentage"
                  value={formData?.referralArray?.[index]?.percentage || ""}
                  onChange={(value) => {
                    if (isNaN(Number(value))) return;

                    // handleChangeVmsChanges("vmsCharges", value)
                    handleChange(`referralArray[${index}].percentage`, value);
                    handleChange(
                      `referralArray[${index}].referralCharges`,
                      toFloat((totalMargin * value) / 100),
                    );
                  }}
                  disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
                %
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="text"
                  title={"Referral Amount"}
                  placeholder="Enter Referral Amount"
                  value={formData.referralArray[index].referralCharges}
                  onChange={
                    (value) =>
                      // handleChangeVmsChanges("vmsCharges", value)
                      handleChange(
                        `referralArray[${index}].referralCharges`,
                        Number(value),
                      )
                    // handleChangeReferralCharges(
                    //   `referralArray[${index}].referralCharges`,
                    //   value,
                    //   index
                    // )
                  }
                  // error={`errors.referralCharges[${index}].referralCharges`}
                  disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* {item.referralChargesType === 2 && (
                <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
                  %
                </div>
              )} */}
            </div>
          </div>
          <div className="col-span-1">
            <div className="flex items-center">
              <div className="flex-1">
                <FormFieldSet
                  type="select"
                  title={"Select Referral Type"}
                  placeholder="Select Referral Type"
                  // value={formData.referralType}
                  value={formData.referralArray[index].referralType}
                  onChange={(value) => {
                    // handleChangeVmsChanges("vmsCharges", value)
                    handleChange(`referralArray[${index}].referralType`, value);
                    handleChange(`referralArray[${index}].referral`, "");
                  }}
                  options={PlacementReferralType}
                  // error={`errors.referralArray[${index}].referralType`}
                  disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
          <div className="col-span-1 ">
            <div className="flex items-center">
              <div
                className={`flex-1 ${
                  formData.referralArray[index].referralType ? "" : "hidden"
                }`}
              >
                <FormFieldSet
                  type={
                    formData.referralArray[index].referralType === 1
                      ? "allVendorsList"
                      : formData.referralArray[index].referralType === 2
                        ? "employeesConsultantFullNames"
                        : ""
                  }
                  title={
                    formData.referralArray[index].referralType &&
                    "Select Referral "
                  }
                  placeholder="Select Referral"
                  value={formData.referralArray[index].referral}
                  onChange={(value) =>
                    // handleChangeVmsChanges("vmsCharges", value)
                    // handleChange("referral", value)
                    handleChange(`referralArray[${index}].referral`, value)
                  }
                  showSearch
                  // error={`errors.referralArray[${index}].referral`}
                  disabled={isEditable ? (activeAction ? false : true) : false}
                />
              </div>
              {/* <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div> */}
            </div>
          </div>
        </div>
      ))}

      {isEditable && (
        <TableAdv
          tableId={`employees_placement_addclientplacement_payments`}
          rows={mappedRows}
          columns={columns}
          // toolbarRight={[
          //   { filterButton: false },
          //   { DropdownMenu: false },
          //   { customSearch: false },
          // ]}
        />
      )}
      <div className="flex gap-3 justify-end mt-3">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={() => handleCancel()}
        />
        <Button
          title={"Save"}
          onClick={() => handleSave()}
          disabled={isEditable ? (activeAction ? false : true) : false}
        />
      </div>
      <PayTypeModal
        open={isPayTypeModalOpen}
        onClose={() => setIsPayTypeModalOpen(false)}
        rowData={formData}
        handleChangeMain={handleChange}
        getProfit={getProfit}
      />
      <PaymentViewModel
        open={placementvisablemodel}
        onClose={() => {
          setplacementvisablemodel(false);
          setSelectedPayments({});
        }}
        rowData={selectedPayments}
        handleChangeMain={handleChange}
        isEditable={isEditable}
      />

      <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={selectedDocuments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
    </div>
  );
};

export default Payments;
